module.exports = __webpack_public_path__ + "static/media/5.ad06adec.png";